export default "Diagnostic CEE gratuit pour copropriétés : identifiez les fiches éligibles et estimez les primes pour vos travaux collectifs (chaufferie, isolation, ventilation) en quelques minutes.";
